import React from "react";
import LoadingStates from "../../constants/states/LoadingStates";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import ReservationRequestsTableView from "../views/ReservationRequestsTableView";
import ReservationHistoryTableView from "../views/ReservationHistoryTableView";
import SpaceReservationStore from "../../stores/SpaceReservationStore";
import LoadingView from "../views/LoadingView";
import ActiveSpaceReservationsTableView from "../views/ActiveSpaceReservationsTableView";



class SpaceReservationsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            "spaceReservationStore": SpaceReservationStore.getState(),
        };
    }

    componentDidMount() {
        this.spaceReservationStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.SPACE_RESERVATIONS_STORE_UPDATED, this.handleStoreUpdate);
        EventPublisher.publish(UIInteractionEvents.GET_MEMBER_SPACES_RESERVATIONS, {});
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.spaceReservationStoreSubscriber);
        EventPublisher.publish(UIInteractionEvents.SPACE_RESERVATIONS_UNMOUNTED, {});
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "spaceReservationStore": SpaceReservationStore.getState(),
        });
    };

    render() {
        if (this.state.spaceReservationStore.loadingState !== LoadingStates.FINISHED_LOADING) {
            return (
                <LoadingView titleText="Loading Space Reservations"/>
            );
        }
        const hash = this._getHashOrDefault();


        return (
            <div className="container mt-13vh">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-12">
                                        <ul className="nav nav-tabs card-header-tabs" id="bologna-list" role="tablist">
                                            <li className="nav-item">
                                                <button
                                                    className={(hash === "#reservation-requests") ? "btn nav-link active": "btn nav-link"}
                                                    id="reservation-requests-tab"
                                                    onClick={(e) => this._changeHashTo(e, "#reservation-requests")}
                                                    role="tab"
                                                    aria-controls="reservation-requests-tab"
                                                    aria-selected="true"
                                                >
                                                    Reservation Requests
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    className={(hash === "#active-reservations") ? "btn nav-link active": "btn nav-link"}
                                                    id="active-reservations-tab"
                                                    onClick={(e) => this._changeHashTo(e, "#active-reservations")}
                                                    role="tab"
                                                    aria-controls="active-reservations"
                                                    aria-selected="false"
                                                >
                                                    Upcoming & Active Reservations
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <a className={(hash === "#history") ? "btn nav-link active": "btn nav-link"}
                                                   id="history-tab"
                                                   href="#history"
                                                   role="tab"
                                                   aria-controls="history-tab"
                                                   aria-selected="false"
                                                >
                                                    History
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <h4 className="card-title">Space Reservation Management</h4>

                                <div className="tab-content mt-3">
                                    <div className={(hash === "#reservation-requests") ? "tab-pane active": "tab-pane fade"} id="reservation-requests" role="tabpanel" aria-labelledby="reservation-requests-tab">
                                        {<ReservationRequestsTableView reservations={this.state.spaceReservationStore.reservationRequests}/>}
                                    </div>
                                    <div className={(hash === "#active-reservations") ? "tab-pane active": "tab-pane fade"} id="active-reservations" role="tabpanel" aria-labelledby="active-reservations-tab">
                                        {<ActiveSpaceReservationsTableView reservations={this.state.spaceReservationStore.activeReservations}/>}
                                    </div>
                                    <div className={(hash === "#history") ? "tab-pane active": "tab-pane fade"} id="unlisted-spaces" role="tabpanel" aria-labelledby="history-tab">
                                        {<ReservationHistoryTableView reservations={this.state.spaceReservationStore.history}/>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    _changeHashTo(event, newHash) {
        event.stopPropagation();
        window.location.hash = newHash;
    }

    _getHashOrDefault() {
        const hash = window.location.hash
        if (hash === "#active-reservations") {
            return hash;
        }
        if (hash === "#history") {
            return hash;
        }
        return "#reservation-requests";
    }
}

export default SpaceReservationsContainer;